import  { Channel } from '../classes/Channel';


let channels = [];
let users = [];
let activeChannel =  new Channel(null);
export default class ChannelHandler {
  constructor(){}
  static init(data){
    channels = data.arrChannel;
    users = data.arrUsers;
    activeChannel = new Channel(null);

  }
  static addChannel(data){
    var channel = new Channel(data);

    if(!channels.includes(channel)){
        channels.push(channel);
    }
    return channel;
  }
  static getChannels(){
    return channels;
  }
  static getUsers(){
    return users;
  }
  static getChannel(cpid){
    return channels.find(
      oChannel => {
        return oChannel.channel_id == cpid;
    })
  }

  static getUser(cpid){
    return users.find(
      UserObject => {
        return UserObject.user_id == cpid;
    })
  }

  static getActiveChannel(){
    return activeChannel;
  }


  static getAllActiveUsersCpIds(){
    let arrUsersCpIds = []
    for(let i=0; i<users.length;i++){
      if(users[i].reachability == 'online'){
        arrUsersCpIds.push(users[i].user_id)
      }
    }
   
    return arrUsersCpIds;
  }
}
